import React, { useEffect, useState } from "react";
import { UserCard } from "../../components/";
import { NavLink, useSearchParams } from "react-router-dom";
import { handleApi } from "../../utils/authentication";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Select from "react-select";
import { useParams } from "react-router-dom";
import LoadingSpinner from "../../components/client/LoadingSpinner";

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: "29px", // minimum height of the control
    height: "29px", // fixed height
    fontSize: "14px", // adjust font size if needed
    fontFamily: "aeonik_medium", // customize font family
    border: state.isFocused ? "1px solid #007bff" : "0px solid #ced4da", // border style
    boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: "29px",
    width: "8.9vw",

    padding: "0 4px", // adjust padding to align text
    display: "flex",
    alignItems: "center",
  }),
  input: (provided) => ({
    ...provided,
    margin: "0",
    padding: "0",
    height: "29px",
  }),
  singleValue: (provided) => ({
    ...provided,
    lineHeight: "29px",
    fontFamily: "aeonik_bold",
    fontSize: "14px",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "29px",
  }),
  indicatorSeparator: () => ({
    display: "none", // remove the default indicator separator
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: "4px",
    color: "#7F56D9",
  }),
};

const ClientMembers = () => {
  const [userList, setUserList] = useState([]);
  const [membersCount, setMemberCount] = useState({});
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("active_clients");
  const [filter, setFilter] = useState({ label: "All", value: 0 });
  const user = useSelector((state) => state?.user);
  const { client_id } = useParams();
  const [page_details, setPageDeatils] = useState({
    current_page: 1,
    last_page: 1,
  });

  const getUsertList = async () => {
    try {
      setLoading(true);
      let method = "POST";
      let headers = {};
      let formData = new FormData();
      formData.append("client_id", client_id);
      if (activeTab === "active_clients") {
        formData.append("status", 1);
      } else if (activeTab === "blocked_clients") {
        formData.append("status", 0);
      } else {
        formData.append("status", -1);
      }

      formData.append("role", filter?.value);

      let result = await handleApi(
        `user_list?page_number=${page_details?.current_page}`,
        method,
        headers,
        formData,
      );
      if (result?.success) {
        setUserList(result?.data?.user_list);
        setMemberCount({
          active: result?.data?.active_members,
          blocked: result?.data?.blocked_members,
          pending: result?.data?.pending_members,
        });
        setPageDeatils({
          current_page: result?.data?.current_page,
          last_page: result?.data?.last_page,
        });
      } else {
        // toast.error(result?.error?.error_message ? result?.error?.error_message : "Users not found", {
        //     position: "top-right",
        //     autoClose: 5000,
        //     hideProgressBar: false,
        //     closeOnClick: true,
        //     pauseOnHover: true,
        //     draggable: true,
        //     progress: undefined,
        //     theme: "light",
        // });
      }
    } catch (e) {
      console.log(e);
      toast.error(e?.message ? e?.message : "Users not found", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getUsertList();
  }, [client_id, activeTab, filter, page_details?.current_page]);

  return (
    <div className="row  d-flex flex-row  m-0 w-100 ">
      <div className="row campaign_header_tab d-flex align-items-center mb-3 ">
        <div className="col-md-12  ">
          <div className=" d-flex gap_lg align-items-center ">
            <div className="   ">
              <span href="" onClick={() => setActiveTab("active_clients")}>
                <p
                  className={`mb-0 ${activeTab === "active_clients" && "campaign_header_tab_active"}`}
                >
                  Active Members ({membersCount?.active})
                </p>
                {activeTab === "active_clients" && (
                  <div
                    style={{ border: "solid 1px #7f56d9" }}
                    className="underline"
                  >
                    {" "}
                  </div>
                )}
              </span>
            </div>
            <div className=" text-center  ">
              <span href="" onClick={() => setActiveTab("blocked_clients")}>
                <p
                  className={`mb-0 ${activeTab === "blocked_clients" && "campaign_header_tab_active"}`}
                >
                  Blocked Members ({membersCount?.blocked})
                </p>
                {activeTab === "blocked_clients" && (
                  <div
                    style={{ border: "solid 1px #7f56d9" }}
                    className="underline"
                  >
                    {" "}
                  </div>
                )}
              </span>
            </div>
            <div className="text-center ">
              <span href="" onClick={() => setActiveTab("pending_clients")}>
                <p
                  className={`mb-0 ${activeTab === "pending_clients" && "campaign_header_tab_active"}`}
                >
                  Onboard Pending Members ({membersCount?.pending}){" "}
                </p>
                {activeTab === "pending_clients" && (
                  <div style={{ border: "solid 1px #7f56d9" }}> </div>
                )}
              </span>
            </div>

            <div className="text-center">
              <div className="d-flex py-lg-1 px-3 d-flex align-items-center bg-white gap-2  rounded">
                <label htmlFor="">Filter User By:</label>
                <Select
                  onChange={(selected_option) => {
                    setFilter(selected_option);
                  }}
                  value={filter}
                  styles={customStyles}
                  isSearchable={true}
                  options={[
                    { label: "All", value: 0 },
                    { label: "Admin", value: 1 },
                    { label: "Member", value: 3 },
                  ]}
                />
              </div>
            </div>
          </div>
        </div>
        {(user?.role_id === 2 || user?.role_id === 1) && (
          <div className="col-lg-2 d-flex justify-content-lg-end">
            <NavLink
              style={{ marginRight: "-6vw" }}
              to="/client/settings/add_user"
              className="btn btn-md  rounded-pill text-center  btn-primary nav_export_stats_btn"
            >
              Create Member
            </NavLink>
          </div>
        )}
        {activeTab === "pending_clients" && (
          <div
            style={{
              fontFamily: "aeonik_medium",
            }}
          >
            <p className="my-2">
              Once the member completes onboarding process it will be listed in{" "}
              <span className="text-success ">Active Members List.</span>{" "}
            </p>
          </div>
        )}
      </div>
      <div className="card campaign_card position-relative  ">
        <div className="d-flex justify-content-between align-items-center  campaign_card_heading ">
          <p className="mb-0">Members List</p>
        </div>
        {/* users list */}
        {loading ? (
          <div className="position-absolute top-50 end-50">
            <LoadingSpinner />
          </div>
        ) : (
          userList?.map((item) => {
            return (
              <UserCard
                key={user?.user_id}
                user={item}
                activeTab={activeTab}
                acive_user={user}
              />
            );
          })
        )}
        {!loading && userList.length == 0 && (
          <div style={{ position: "absolute", left: "37%", top: "50%" }}>
            <div>
              <h5>No Members To Display</h5>
            </div>
          </div>
        )}
      </div>
      <nav aria-label="Page navigation example">
        <ul className="pagination justify-content-center">
          <li
            className={`page-item ${page_details?.current_page <= 1 && "disabled"} `}
            onClick={() => {
              page_details?.current_page > 0 &&
                setPageDeatils({
                  ...page_details,
                  current_page: page_details?.current_page - 1,
                });
            }}
          >
            <span
              className={`page-link ${page_details?.current_page <= 1 && "disabled"}`}
              tabindex="-1"
            >
              Previous
            </span>
          </li>
          {Array.from(
            { length: page_details?.last_page },
            (_, index) => index + 1,
          ).map((page) => {
            return (
              <li
                key={page}
                className={`page_item ${page_details?.current_page === page && "active"}`}
                onClick={() => {
                  setPageDeatils({ ...page_details, current_page: page });
                }}
              >
                <span className="page-link">{page}</span>
              </li>
            );
          })}
          <li
            className={`page-item  ${page_details?.current_page === page_details?.last_page && "disabled"}`}
            onClick={() => {
              page_details?.current_page < page_details?.last_page &&
                setPageDeatils({
                  ...page_details,
                  current_page: page_details?.current_page + 1,
                });
            }}
          >
            <span className="page-link">Next</span>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default ClientMembers;
